{
  "app.name": "404 Estate",
  "app.poweredBy": "Powered by 404 Estate",
  "app.poweredByPrefix": "Powered by",
  "app.craftedBy": "A 404 Creative product",

  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.save": "Save",
  "common.saveChanges": "Save changes",
  "common.create": "Create",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.retry": "Try again",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.search": "Search",
  "common.filters": "Filters",
  "common.clearFilters": "Clear filters",
  "common.all": "All",
  "common.none": "None",
  "common.loading": "Loading…",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.copiedToast": "Copied to the clipboard.",
  "common.copyFailed": "Could not copy. Select the text and copy it yourself.",
  "common.optional": "Optional",
  "common.notSet": "Not set",
  "common.more": "More actions",
  "common.open": "Open",
  "common.download": "Download",
  "common.upload": "Upload",
  "common.yes": "Yes",
  "common.no": "No",
  "common.today": "Today",
  "common.view": "View",
  "common.unassigned": "Unassigned",
  "common.you": "You",

  "combobox.clear": "Clear selection",
  "filters.clear": "Clear filter",
  "filters.clearOne": "Clear the {filter} filter",
  "filters.clearSearch": "Clear search",
  "filters.searchIn": "Search {filter}…",
  "filters.noOptions": "No matches",
  "filters.from": "From",
  "filters.to": "To",
  "filters.created": "Created",
  "pagination.label": "Pages",
  "pagination.range": "{from}–{to} of {total}",
  "selection.label": "Selected rows",
  "selection.count": "{count, plural, one {# selected} other {# selected}}",
  "selection.clear": "Clear selection",
  "selection.first": "Select the first",
  "selection.firstAction": "Select",
  "selection.moveTo": "Move to",
  "dataTable.sortBy": "Sort by {column}",
  "dataTable.selectAll": "Select all rows",
  "dataTable.selectRow": "Select {name}",
  "date.pick": "Pick a date",
  "reason.label": "Reason",
  "reason.tooShort": "Write a reason of at least {min} characters.",

  "errors.generic": "Something went wrong. Please try again.",
  "errors.network": "Can't reach the server. Check your connection and try again.",
  "errors.forbidden": "You don't have permission to do that.",
  "errors.validation": "Some fields need your attention.",
  "errors.sessionExpired": "Your session has ended. Sign in again to continue.",
  "errors.notFound.title": "This page doesn't exist",
  "errors.notFound.body": "The link may be broken, or the page may have moved.",
  "errors.notFound.home": "Back to home",
  "errors.unexpected.title": "Something broke on this page",
  "errors.unexpected.body": "The error has been noted. Reload the page, or head back home.",
  "errors.unexpected.home": "Back to home",
  "errors.noAccess.title": "You don't have access to {area}",
  "errors.noAccess.body": "Ask an admin to enable it for your role in Team › Roles.",
  "errors.unavailable.body": "Your session is safe. Check your connection, then try again.",
  "errors.notFound.search": "to search everything",

  "board.moved": "{name} moved to {status}",
  "board.drop": "Drop here to move",
  "board.empty": "Nothing here",
  "board.more": "{count} more: narrow with the filters",
  "board.movedMany": "Moved {count} to {status}",
  "board.selectCard": "Select {name}",
  "board.selectColumn": "Select everything in {status}",
  "board.oneByOne": "One at a time",
  "shell.skipToContent": "Skip to content",
  "shell.mainNavigation": "Main navigation",
  "shell.collapseSidebar": "Collapse sidebar",
  "shell.expandSidebar": "Expand sidebar",
  "shell.openMenu": "Open menu",
  "shell.breadcrumb": "Breadcrumb",
  "shell.moreTabs": "More",
  "shell.search": "Search or jump to…",
  "shell.quickCreate": "Create",
  "shell.account": "Account",
  "shell.profile": "Your profile",
  "shell.signOut": "Sign out",
  "shell.about": "About 404 Estate",
  "shell.shortcuts": "Keyboard shortcuts",

  "palette.title": "Command palette",
  "palette.placeholder": "Search leads, units and deals, or jump anywhere…",
  "palette.empty": "Nothing matches. Try a name, phone number or unit code.",
  "palette.navigation": "Go to",
  "palette.actions": "Actions",
  "palette.records": "Records",
  "palette.hintMove": "to move",
  "palette.hintOpen": "to open",

  "create.lead": "New lead",
  "create.coldCall": "New cold call",
  "create.unit": "New unit",
  "create.event": "New event",
  "create.request": "New request",

  "shortcuts.palette": "Open the command palette",
  "shortcuts.sidebar": "Fold or unfold the sidebar",
  "shortcuts.search": "Search this page",
  "shortcuts.createHere": "Create on this page",
  "shortcuts.goHome": "Go to Home",
  "shortcuts.goLeads": "Go to Leads",
  "shortcuts.goUnits": "Go to Units",
  "shortcuts.goPipeline": "Go to Pipeline",
  "shortcuts.goRequests": "Go to Requests",
  "shortcuts.goCalendar": "Go to Calendar",
  "shortcuts.help": "Show these shortcuts",
  "shortcuts.close": "Close a panel or dialog",
  "shortcuts.then": "then",

  "about.body": "{company}'s workspace for listings, leads and deals. 404 Estate is designed and built by 404 Creative, a full-stack tech and growth agency.",
  "about.version": "Version {version}",

  "nav.home": "Dashboard",
  "nav.calendar": "Calendar",
  "nav.group.clients": "Clients",
  "nav.leads": "Leads",
  "nav.coldCalls": "Cold calls",
  "nav.farming": "Resale",
  "nav.group.sales": "Sales",
  "nav.pipeline": "Pipeline",
  "nav.requests": "Requests",
  "nav.group.inventory": "Inventory",
  "nav.units": "Units",
  "nav.claims": "Claims",
  "nav.group.team": "Team",
  "nav.team": "Team & roles",
  "nav.tips": "Tips",
  "nav.group.setup": "Setup",
  "nav.catalog": "Developers & projects",
  "nav.statuses": "Lead statuses",
  "nav.workingHours": "Working hours",
  "nav.stages": "Pipeline stages",
  "nav.unitTags": "Unit tags",
  "nav.sources": "Lead sources",
  "nav.campaigns": "Campaigns",
  "nav.areas": "Areas",

  "role.admin": "Admin",
  "role.team_leader": "Team leader",
  "role.agent": "Agent"
}
